import { useLanguage } from "../../languageContext";
import translations from "../../translation.json";

const CALLBACK_USER_TYPES = [
  "Super Admin",
  "Admin",
  "Representative",
  "Animator",
];

// Pass activePage to override the current URL's page when highlighting a button.
const HeaderNavButtons = ({
  eventId,
  setDisplayComponent,
  activePage = new URLSearchParams(window.location.search).get("page"),
  showStatusReport = false,
  className = "justify-content-lg-end",
}) => {
  const { language } = useLanguage();
  const canViewCallbacks = CALLBACK_USER_TYPES.includes(
    localStorage.getItem("userType"),
  );

  const pages = [
    {
      page: "event-view",
      parameter: "event_id",
      icon: "bi-speedometer",
      label: translations.eventView.buttons.dashboard[language],
    },
    {
      page: "appointments",
      parameter: "eventId",
      icon: "bi-calendar2-range",
      label: translations.eventView.buttons.calender[language],
    },
    {
      page: "clients",
      parameter: "eventId",
      icon: "bi-people",
      label: translations.forms.formFields.clients[language],
    },
    {
      page: "callback-list",
      parameter: "eventId",
      icon: "bi-telephone",
      label: translations.eventView.buttons.callbacks[language],
    },
    {
      page: "copy-client",
      parameter: "eventId",
      icon: "bi-clipboard-plus",
      label: translations.forms.formFields.copyClient[language],
    },
    {
      page: "eventReport",
      parameter: "event_id",
      icon: "bi-file-earmark-bar-graph",
      label: translations.viewEventReport.title[language],
    },
    ...(showStatusReport
      ? [{
          page: "event-status-report",
          parameter: "event_id",
          icon: "bi-list-check",
          label: translations.topAndsidebar.statusReport[language],
        }]
      : []),
  ].filter((page) => page.page !== "callback-list" || canViewCallbacks);

  const navigateToPage = ({ page, parameter }) => {
    setDisplayComponent(page);
    window.history.pushState(
      { id: "gallery", randomData: window.Math.random() },
      "title",
      `/event-portal?page=${page}&${parameter}=${encodeURIComponent(eventId)}`,
    );
  };

  return (
    <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`}>
      {pages.map((page) => {
        const isActive = page.page === activePage;

        return (
          <button
            key={page.page}
            type="button"
            className={`btn d-inline-flex align-items-center gap-1 flex-shrink-0 text-nowrap${
              isActive ? "" : " admin-btn btn-primary"
            }`}
            style={
              isActive
                ? {
                    background: "#05cc9e",
                    borderColor: "#05cc9e",
                    color: "#000000",
                  }
                : undefined
            }
            aria-current={isActive ? "page" : undefined}
            disabled={!eventId}
            onClick={() => navigateToPage(page)}
          >
            <i className={`bi ${page.icon}`} aria-hidden="true" />
            {page.label}
          </button>
        );
      })}
    </div>
  );
};

export default HeaderNavButtons;
